var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-xs",on:{"click":_vm.submit}},[_vm._v("カードを削除")])}
var staticRenderFns = []

export { render, staticRenderFns }